<section class="confirm-modal">
	<section class="confirm-modal__close">
		<button class="btn btn-lg" type="button" (click)="dismissModal()">
			<i class="bi bi-x-lg"></i>
		</button>
	</section>
	<main class="confirm-modal__content">
		<p class="text-center mx-5">{{ modalText }}</p>
		<button class="btn btn-cta block mt-5" (click)="onConfirm()">
			{{ btnText }}
		</button>
	</main>
</section>
